module.exports = __webpack_public_path__ + "static/media/logout.84584759.svg";